export const processPermissionsConst = {
  view: {
    value: "view_process",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu procesów!",
  },
  add: {
    value: "add_process",
    errorMsg: "Użytkownik nie ma uprawnień do dodania procesów!",
  },
  update: {
    value: "change_process",
    errorMsg: "Użytkownik nie ma uprawnień do edycji procesów!",
  },
  delete: {
    value: "delete_process",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania procesów!",
  },
};

export const processStagePermissionsConst = {
  view: {
    value: "view_processstage",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu etapów procesu!",
  },
  add: {
    value: "add_processstage",
    errorMsg: "Użytkownik nie ma uprawnień do dodania etapów procesu!",
  },
  update: {
    value: "change_processstage",
    errorMsg: "Użytkownik nie ma uprawnień do edycji etapów procesu!",
  },
  delete: {
    value: "delete_processstage",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania etapów procesu!",
  },
};
